<div class="p-3 position-relative">
  <h3 class="pb-3 ps-2">Actualités</h3>
  <fa-icon class="quote-right text-primary transparent-3" icon="quote-right" size="2x"></fa-icon>
  @if (news | async; as n) {
    <div>
      @for (info of n; track info) {
        <div class="p-2 infos" (click)="followNewsLink(info.link)">
          <div class="fw-bold">{{ info.title }}</div>
          <div>{{ info.published | date:'d MMMM y' }}</div>
        </div>
      }
    </div>
  } @else {
    <ls-spinner/>
  }
  <div class="pt-4 position-relative d-flex flex-column">
    <fa-icon class="text-primary transparent-3" icon="quote-right" size="2x" flip="horizontal"></fa-icon>
    <div class="mt-2">
      <a href="https://www.libriciel.fr/blog" target="_blank" class="btn btn-outline-info float-end">
        Voir toutes les actualités
      </a>
    </div>
  </div>
</div>
